import { Button } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import React from "react";
import classes from "./Scheduler.module.css";
import LessonPlanIcon from "../../assets/img/schedulerImages/lessonPlan.svg";
import ThirdPartyIcon from "../../assets/img/schedulerImages/thirdParty.svg";
import config from "../../Kneura-Web-Whiteboard/IWB/config";
import { get } from "../../utils/api-authentication";
import {
  getInstituteKneuraId,
  getKneuraId,
  setBoardInfo,
} from "../../utils/authentication-access";
import { CLASSES } from "../../utils";
import BaseService from "../../store/services/base.service";

function SingleEntryRow(props) {
  const showLessonPlan = async () => {
    const url = CLASSES.getWhiteBoardInfo(props.flowId);
    const info = await new BaseService().makeGetRequestGeneric(url);
    sessionStorage.setItem("boardinfo", JSON.stringify(info));
    window.location.href = "/class";
  };
  return (
    <>
      <div className={classes.singleContent}>
        <img
          src={
            props.type === "LIVE_CLASS" || props.type === "GO_LIVE"
              ? LessonPlanIcon
              : ThirdPartyIcon
          }
        />
        <div className={classes.ContentName}>{props.name || "Test Lesson"}</div>
        <div>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            style={{
              textTransform: "capitalize",
              borderRadius: "2px",
              height: "3.7vh",
            }}
            className="btn-button"
            onClick={showLessonPlan}
          >
            {props.type === "GO_LIVE" ? "Go Live" : "Join"}
          </Button>
        </div>
      </div>
      <Divider />
    </>
  );
}

export default SingleEntryRow;
